import { render, staticRenderFns } from "./BorcluCardInfo.vue?vue&type=template&id=b1be7032"
import script from "./BorcluCardInfo.vue?vue&type=script&lang=ts"
export * from "./BorcluCardInfo.vue?vue&type=script&lang=ts"
import style0 from "./BorcluCardInfo.vue?vue&type=style&index=0&id=b1be7032&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports